import type {IssueAttachmentMetadata} from "@/pb/api/devplan/types/attachments"
import type {AttachmentInfo} from "@/hooks/use-unified-file-upload"

// Shape stashed in sessionStorage by the scoping intake dialog and replayed
// by the workspace_chat initializer as the first user message after the
// chat opens.
export interface ScopingInitialBrief {
  description: string
  imageUrls: string[]
  attachmentIds: string[]
  attachments?: AttachmentInfo[]
  issueAttachments: IssueAttachmentMetadata[]
}

export const scopingInitialBriefKey = (chatId: string) => `scoping-chat:initial-brief:${chatId}`

export function readScopingInitialBrief(chatId: string): ScopingInitialBrief | undefined {
  if (typeof sessionStorage === "undefined") return undefined
  const raw = sessionStorage.getItem(scopingInitialBriefKey(chatId))
  if (!raw) return undefined
  try {
    return JSON.parse(raw) as ScopingInitialBrief
  } catch {
    return undefined
  }
}

export function writeScopingInitialBrief(chatId: string, brief: ScopingInitialBrief): void {
  if (typeof sessionStorage === "undefined") return
  sessionStorage.setItem(scopingInitialBriefKey(chatId), JSON.stringify(brief))
}

export function clearScopingInitialBrief(chatId: string): void {
  if (typeof sessionStorage === "undefined") return
  sessionStorage.removeItem(scopingInitialBriefKey(chatId))
}
